import { render, staticRenderFns } from "./ParisHintPopup.vue?vue&type=template&id=2d72185a&scoped=true&"
import script from "./ParisHintPopup.vue?vue&type=script&lang=js&"
export * from "./ParisHintPopup.vue?vue&type=script&lang=js&"
import style0 from "./ParisHintPopup.vue?vue&type=style&index=0&id=2d72185a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72185a",
  null
  
)

export default component.exports